// Who a conversation can be handed to — shared by Bandeja and Supervisión.
//
// Both screens used to fetch GET /team/assignable under their own query key, and
// only once the reassign modal was already open. That made "Reasignar" a painted
// door for a lone Dueño: the button rendered, the modal opened, and the Select
// offered nothing but "Elige a una persona…". The list has to be in hand BEFORE
// the affordance renders, so the page can decide there is nobody else to hand
// the conversation to.
//
// One query key for both callers: react-query dedupes it, so the two pages (and
// the modal inside each) share a single request.

import { useQuery } from '@tanstack/react-query'

import { type AssignableMember, getAssignableMembers } from './oversight-data.js'

export interface AssignableMembersState {
  members: AssignableMember[]
  isLoading: boolean
  /** There is somebody OTHER than you to hand a conversation to. A list of one
   *  is you alone (solo mode), and reassigning to yourself is not a thing. */
  canReassign: boolean
}

export function useAssignableMembers(): AssignableMembersState {
  const { data, isLoading } = useQuery({
    queryKey: ['assignable-members'],
    queryFn: getAssignableMembers,
  })
  const members = data ?? []
  return { members, isLoading, canReassign: members.length > 1 }
}
